import React from 'react';
import Menu from 'components/Menu';

const Header = ({ ...props }) => <Menu {...props} />;

export default Header;
